import { RootState } from '@/store';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import type {
  Dispatch,
  Middleware,
  MiddlewareAPI,
  UnknownAction,
} from '@reduxjs/toolkit';

import { msalInstance } from '@/utils/auth';

interface ErrorPayload {
  status: number;
}

export const errorLoggerMiddleware: Middleware =
  (_: MiddlewareAPI<Dispatch<UnknownAction>, RootState>) =>
  (next) =>
  (action: unknown) => {
    if (!isRejectedWithValue(action)) {
      return next(action as UnknownAction);
    }

    if ((action?.payload as ErrorPayload)?.status === 401) {
      msalInstance.logoutRedirect();
    }

    return next(action);
  };
